import { createFileRoute } from '@tanstack/react-router';

import { useSEO, useBreadcrumbSchema, PageSEO } from '../lib/seo';
import { LegalDocPage } from '../components/legal/LegalDocPage';
import { DocWarning } from '../components/legal/DocWarning';
// Body extracted verbatim from sites/www/public/legal/eula/index.html (see privacy.tsx note).
import eulaBody from '../content/legal/eula.body.html?raw';

export const Route = createFileRoute('/legal/eula')({
  component: EulaPage,
});

function EulaPage() {
  useSEO(PageSEO.eula);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust', url: '/trust' },
    { name: 'App EULA', url: '/legal/eula' },
  ]);

  return (
    <LegalDocPage
      title="Neumind App End User Licence Agreement"
      breadcrumbLabel="App EULA"
      metaLine="Last updated 21 April 2026"
      subtitle="The terms on which you (the user) may download, install, and use the Neumind mobile application."
      warning={
        <DocWarning summary="Please read these licence terms carefully">
          <p>
            <em>
              By downloading the App you agree to these terms. If you do not agree to these terms,
              do not download the App.
            </em>
          </p>
        </DocWarning>
      }
    >
      <div dangerouslySetInnerHTML={{ __html: eulaBody }} />
    </LegalDocPage>
  );
}
